import * as React from "react";
import {formStores} from "../../../state/mobx";
import {CoverageState} from "../../../state/CoverageState";
import {observer} from "mobx-react";
import FormFinish from "../../SignUpForm/FormFinish/FormFinish";
import {RouteComponentProps} from "react-router-dom";
import LottieAnimation from "../../../../../components/LottieAnimation/LottieAnimation";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import FormFinancialContainer from "../../SignUpForm/FormFinancial/FormFinancialContainer";
import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core";
import Loader from "../../../../../components/Loader/Loader";

interface IProps extends RouteComponentProps<any> {
    closeWindowNavigationPath : string;
}

const STORE = formStores.coverageStore;
const storePropertyName = 'coverage';

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
    error: {
        fontSize: 13,
        color: "#E96767",
        width: "90%",
        marginLeft: "auto"
    }
});

@(withStyles(styles) as any)
@observer
export default class FormCoverage  extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {

    constructor (props: IProps) {
        super(props);
        STORE.formInput= {plans: { plansValue: LeadPlanType.Loan}};
        if(!STORE.formInput[storePropertyName]) {
            STORE.formInput[storePropertyName] = {plans: { plansValue: LeadPlanType.Loan}};
        }
    }

    public renderSteps = () => {
        switch (STORE.currentScreen) {
            case CoverageState.financial: {
                return <><FormFinancialContainer isAmountLocked = {false} store={STORE}/></>
            }
            case CoverageState.finish: return <FormFinish {...this.props} store={STORE} newPlanRequest={true}/>
            default: return null
        }
    };

    public render() {
        return (STORE.isSending? <div className={"loader-container"}><Loader/></div> : this.renderForm())
    }
    private renderForm = () => {
        return (
            (<>
                {STORE.showVerified?
                    <div className="lottie-container">
                        <LottieAnimation animationName={'greenCheckmark'}/>
                        <div className="verified-text"> Your account is now connected </div>
                    </div>
                    :this.renderSteps()}
                {this.renderErrorIfNeeded()}
            </>)
        )
    };

    private renderErrorIfNeeded = () => {
        const {classes} = this.props;
        return STORE.error?<div className={classes!.error}>There was an error processing your new loan request, please connect our <a href="mailto:support@salaryo.com">
            customer support
        </a> or try again later </div> : null
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormAddCoverage/FormCoverage/FormCoverage.tsx